import { ChartData } from 'components/chart/data/ChartData';

export class BandChartData extends ChartData {
  constructor(
    public label?: string,
    public value?: number,
    public lower?: number,
    public upper?: number,
    public isOther?: boolean,
    public secondLabel?: string,
    public colorIndex?: number
  ) {
    super(label, value, isOther, secondLabel, colorIndex);
  }
}
